import { render, staticRenderFns } from "./ServiceRanking.vue?vue&type=template&id=6ff884e6&scoped=true&"
import script from "./ServiceRanking.vue?vue&type=script&lang=js&"
export * from "./ServiceRanking.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRanking.vue?vue&type=style&index=0&id=6ff884e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff884e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VChip,VCol,VContainer,VDataTable,VRow,VSelect,VSnackbar})
